module.exports = __webpack_public_path__ + "static/media/52.807bb71d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/52.jpg
// module id = 742
// module chunks = 0